function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgMcap = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M11.649 5.298c.418-.122.861.002 1.222.22 1.609.922 3.225 1.83 4.848 2.727.624.33 1.04 1.01 1.031 1.71-.002 2.32-.008 4.642-.004 6.963.026.161-.084.345-.267.328-.72.005-1.441.002-2.162.001-.157.023-.309-.109-.293-.268-.069-1.977-.042-3.955-.022-5.933 0-.247-.048-.508-.208-.709-.162-.212-.418-.32-.646-.447-.375-.196-.729-.434-1.117-.606-.147-.058-.338-.121-.477-.01-.154.145-.152.374-.168.569-.028.97-.031 1.94-.008 2.91-.001.23.006.496-.169.675-.18.175-.45.178-.685.182-.426-.004-.852.011-1.277-.01-.18-.019-.396-.03-.513-.187-.105-.155-.1-.351-.11-.53-.002-1.019.011-2.039 0-3.057-.01-.18-.007-.383-.135-.525-.122-.126-.317-.085-.464-.032-.318.125-.604.315-.906.473-.303.174-.627.322-.887.56-.169.153-.214.387-.219.603-.004 2.003.002 4.004-.015 6.006.017.151-.073.336-.25.333-.742.009-1.485.004-2.227.002-.149.015-.285-.116-.27-.264.03-2.433.011-4.868.013-7.302a1.386 1.386 0 01.718-1.253c1.691-.948 3.386-1.89 5.07-2.85.19-.107.383-.22.597-.279z",
    fill: "white"
  }));
});
SvgMcap.displayName = "SvgMcap";
SvgMcap.defaultProps = {
  size: 24,
  color: "#033B4A"
};
export default SvgMcap;